<form [formGroup]="productForm" >

    <!-- <div > -->
        <table>
            <tr>
                <td style="width: 125px;padding-left: 5px;"><button class="buttonHeaderHome" (click)="DivEditVul()" autofocus >Edit Vulnerability Record</button></td>                                              
                <td style="width: 125px;padding-left: 5px;"><button class="buttonHeaderHome" (click)="DivUpdateCDL()">Update CDL</button></td>                                              
            </tr>   
        </table>
    
        <div *ngIf="isShown">
            <div class="catcontainer" style="margin-left: 5px; width: 1100px; margin-top: 10px; height: fit-content; border-radius: 20px;">
                <table>
                    <tr>
                        <h3 style="font-weight: 500; margin-left: 5px; margin-top: 15px;">Vulnerability Details</h3>
                    </tr>
                </table>
                <table style="margin-left: 5px;">
                    <tr>
                        <td><label style="width: 163px; font-weight: 600; display: inline-block; margin: 8px 5px;">Source Vulnerability</label></td>
                        <td><label style="width: 125px; font-weight: 600; margin: 8px 4px;">Target Vulnerability</label></td>
                    </tr>
                    <tr>
                        <td>
                            <mat-form-field class="width" appearance="outline" style="display: inline-block; margin: 8px 5px;">
                                <mat-select [formControl]="SourceVulServerSideCtrl" id="SourceVulServerSideCtrl" placeholder="Source" #matClient (selectionChange)="onSrcVulSelChange($event)">
                                    <mat-option>
                                        <ngx-mat-select-search [formControl]="SourceVulServerSideFilteringCtrl" placeholderLabel="Find Source..." noEntriesFoundLabel="'No matching Source found'"></ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let Clientopt of filteredSource | async" [value]="Clientopt">
                                        {{Clientopt}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="width" appearance="outline" style="margin: 8px 4px;">
                                <mat-select [formControl]="TargetVulServerSideCtrl" placeholder="Target" #matContract (selectionChange)="onTargetVulSelChange($event)">
                                    <mat-option>
                                        <ngx-mat-select-search [formControl]="TargetVulServerSideFilteringCtrl" placeholderLabel="Find Target..." noEntriesFoundLabel="'No matching Target found'"></ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let ContNumopt of filteredTargetVul | async" [value]="ContNumopt">
                                        {{ContNumopt}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <button (click)="UpdateData()" style="margin-left: 30px; margin-bottom: 25px;" [disabled]="isButtonDisabled" class="buttonnewvul">Update</button>
                        </td>
                    </tr>
                    
                </table>
                <table>
                    <tr>
                        <td>
                            <div class="flex-container">
                                <!-- font-weight: 600; -->
                                <input matInput style="text-overflow: ellipsis; margin-left: 12px;" id="sourceContNum" formControlName="sourceContNum" disabled >
                                <label style="width: 125px;  margin: 8px -98px;">Contracts marked Out of Scope</label>
                            </div>
                        </td>
                        <td style="padding-left: 80px;">
                            <div class="flex-container">
                                <!-- font-weight: 600; -->
                                <input matInput style="text-overflow: ellipsis; margin: auto;" id="targetContNum" formControlName="targetContNum" disabled >
                                <label style="width: 125px;  margin: 8px -98px;">Matching Contracts</label>
                            </div>
                        </td>
                        <!-- <td></td> -->
                    </tr>
                </table>
            </div>        
        </div>
    
        <div *ngIf="!isShown">
            <div class="catcontainer" style="margin-left: 5px; width: 1100px; margin-top: 10px; height: fit-content; border-radius: 20px;">
                <tr style="height: 12px;"></tr>
                <table style="margin-left: 5px;">
                    <tr>
                        <td><label style="margin-left: 43px;padding-right: 10px;font-weight: bold;" for="updatingVal">Choose a Value:</label></td>
                        <td ><label style="width:100px;font-weight: 600;margin-left: 43px;">Contract</label></td> 
                        <td><label style="margin-left: 23px;padding-right: 10px;font-weight: bold;" >Select New CDL/IOCSDM</label></td>
                        
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;">
                            <mat-form-field appearance="outline">
                                <mat-label>Choose a Value</mat-label>
                        
                                <mat-select formControlName="updatingVal">
                                    <mat-option *ngFor="let sport of updatingVal" [value]="sport">
                                        {{ sport }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td style="padding-right: 10px;">
                            <mat-form-field class="width" appearance="outline">
                                <mat-select formControlName="contract" placeholder="Contract" #matContract>
                                  
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="ContNumServerSideFilteringCtrl" placeholderLabel="Find Contract..."
                                        noEntriesFoundLabel="'No matching Contract found'"></ngx-mat-select-search>
                                </mat-option>
                                  <mat-option *ngFor="let ContNumopt of filteredContNum | async" [value]="ContNumopt" >
                                    {{ContNumopt}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                        </td>
                        <td style="width:250px">
                  
                            <mat-form-field class="example-full-width" appearance="fill">
                                <mat-label>User</mat-label>
                              <!-- [formControl]="delegateControl" -->
                                <input type="text"
                                       matInput
                                       placeholder="Search User"
                                       formControlName="user"
                                       [matAutocomplete]="auto">
                              
                                <mat-autocomplete #auto="matAutocomplete"
                                                  (optionSelected)="isOptionSelected($event)"
                                                  [displayWith]="displayFn">
                              
                                  <mat-option *ngFor="let option of filteredUsers | async"
                                              [value]="option">
                                    {{ option }}
                                  </mat-option>
                              
                                </mat-autocomplete>
                              </mat-form-field>
                              
                              <img src="assets/People.png" style="width:25px;height:25px;margin-right: 14px;" />                            
                              
                      </td> 
                    <td>
                        <button class="buttonnewvul" (click)="updateCDLData()" [disabled]="productForm.invalid" style="margin-top: -15px;">
                            Update CDL
                        </button>
                    </td>
                    </tr>
                </table>
            
        
            <!-- <p>Selected sport: {{ selectedValue }}</p> -->
            <!-- <p>Selected sport: {{ productForm.get('updatingVal')?.value }}</p> -->
            </div>
            
        </div>
    </form>